// extracted by mini-css-extract-plugin
module.exports = {"bankReportFooter":"styles_bankReportFooter__2gwR8"};